import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import type { Testimonial } from '../types/content';
type TestimonialMarqueeProps = {
  testimonials: Testimonial[];
  durationSeconds?: number;
  reverse?: boolean;
};
export function TestimonialMarquee({
  testimonials,
  durationSeconds = 38,
  reverse = false
}: TestimonialMarqueeProps) {
  const track = [...testimonials, ...testimonials];
  return <div className="marquee group relative -mx-5 overflow-hidden px-5" data-id="element-183" data-mp="1mpw7jah8y1he">
      <ul className="marquee-track flex w-max gap-3" style={{
      animationDuration: `${durationSeconds}s`,
      animationDirection: reverse ? 'reverse' : 'normal'
    }} data-id="element-184" data-mp="1qqf0x8ysfflp">
        {track.map((testimonial, index) => <li key={`${testimonial.name}-${index}`} className="w-[300px] shrink-0 sm:w-[340px]" aria-hidden={index >= testimonials.length} data-id="element-185" data-mp="20hsul0425l6x" data-mpi={index}>
            <TestimonialCard testimonial={testimonial} data-id="element-186" data-mp="17yvvywl7drh1" />
          </li>)}
      </ul>
      <div className="marquee-fade pointer-events-none absolute inset-y-0 left-0 w-10" aria-hidden="true" data-id="element-187" data-mp="2v03y656brdz7" />
      <div className="marquee-fade-right pointer-events-none absolute inset-y-0 right-0 w-10" aria-hidden="true" data-id="element-188" data-mp="2r0by6guzyg5g" />
    </div>;
}